import { z } from 'zod';

export const emailSchema = z
  .string()
  .trim()
  .toLowerCase()
  .pipe(z.email('Enter a valid email address'));

export const loginRequestSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, 'Enter your password').max(200),
});
export type LoginRequest = z.infer<typeof loginRequestSchema>;

export const registerRequestSchema = z.object({
  displayName: z.string().trim().min(1, 'Enter your name').max(60),
  email: emailSchema,
  password: z.string().min(8, 'Use at least 8 characters').max(200),
  /** From an invitation link: lets someone in while open sign-up is off. */
  inviteToken: z.string().trim().min(20).max(200).optional(),
});
export type RegisterRequest = z.infer<typeof registerRequestSchema>;

export const authUserSchema = z.object({
  id: z.number().int(),
  email: z.string(),
  displayName: z.string(),
  /** Named in SUPER_USER_EMAIL: can invite people even while sign-up is closed. */
  // Defaults so a user saved on the device by an older version still reads.
  superUser: z.boolean().default(false),
});
export type AuthUser = z.infer<typeof authUserSchema>;

export const authResponseSchema = z.object({
  token: z.string(),
  user: authUserSchema,
});
export type AuthResponse = z.infer<typeof authResponseSchema>;

/** What the sign-in screen needs to know before anyone is signed in. */
export const authConfigSchema = z.object({
  registrationOpen: z.boolean(),
});
export type AuthConfig = z.infer<typeof authConfigSchema>;
